import listaBibliotecaMidiaDigital from './tabela-biblioteca-midia-digital'

export default listaBibliotecaMidiaDigital
